import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Box, List, ListItem, Typography } from '@mui/material';
import React, { useState } from 'react';
import { NewsItem } from '../../../../../../../corelogic/domain/models/hub.model';
import { newsItems } from '../Contents/newsContent';
import NewsItemModal from './NewsItemModal';

const NewsHub: React.FC = () => {
  const [selectedNews, setSelectedNews] = useState<NewsItem | null>(null);

  return (
    <>
      <List
        sx={{
          width: '100%',
          height: '100%',
          overflow: 'auto',
        }}
      >
        {newsItems.map((item) => (
          <ListItem
            key={item.id}
            onClick={() => setSelectedNews(item)}
            sx={{
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              borderRadius: '4px',
              mb: 1,
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <Box sx={{ width: '100%' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <InfoOutlinedIcon
                  sx={{
                    color: 'white',
                    fontSize: 'clamp(1rem, 1.5vw, 1.5rem)',
                    display: 'flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                  }}
                />
                <Typography
                  sx={{
                    color: 'white',
                    fontFamily: 'Bebas Neue',
                    fontSize: 'clamp(1rem, 1.5vw, 1.5rem)',
                  }}
                >
                  {item.title}
                </Typography>
              </Box>
              <Box
                sx={{
                  height: '2px',
                  width: '100%',
                  backgroundImage:
                    'linear-gradient(to right, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%)',
                  backgroundPosition: 'bottom',
                  backgroundSize: '100% 1px',
                  backgroundRepeat: 'no-repeat',
                  mb: 0.5,
                }}
              />
              <Typography
                sx={{
                  color: 'rgba(255, 255, 255, 0.7)',
                  fontSize: 'clamp(0.8rem, 1.4vw, 0.8rem)',
                  mb: 0.5,
                }}
              >
                {item.date}
              </Typography>
              <Typography
                sx={{
                  color: 'rgba(255, 255, 255, 0.5)',
                  fontSize: 'clamp(0.9rem, 1.6vw, 0.9rem)',
                }}
              >
                {item.shortDescription}
              </Typography>
            </Box>
          </ListItem>
        ))}
      </List>

      <NewsItemModal
        open={!!selectedNews}
        onClose={() => setSelectedNews(null)}
        title={selectedNews?.title || ''}
        date={selectedNews?.date || ''}
        content={selectedNews?.fullContent || ''}
      />
    </>
  );
};

export default NewsHub;
